import(/* webpackMode: "eager" */ "/pri/app/global-error.tsx")